import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '@App/components/Navbar/Navbar'
import ScreenNotSupported from '@App/components/ScreenNotSupported/ScreenNotSupported'

import './course-modules.styl'

function CourseModules() {
  return (
    <div className="course-modules">
      <ScreenNotSupported />
      <Navbar />
      <Outlet />
    </div>
  )
}

export default CourseModules